import { AccessLevelType } from "@/data/AccessLevel";
import { useStudioStream } from "@/data/studio-react/useStudioStream";

/**
|--------------------------------------------------
| AccessLevelControl
|--------------------------------------------------
| This component is used to control the access level of a component.
| It will only render the children if the access level is greater than or equal to the minAccessLevel.
|--------------------------------------------------
*/
export function AccessLevelControl({
  children,
  minAccessLevel,
}: {
  children: React.ReactNode;
  minAccessLevel: AccessLevelType;
}) {
  let accessLevel = useStudioStream("session:accessLevel");

  if (accessLevel && accessLevel >= minAccessLevel) {
    return <>{children}</>;
  }
  return null;
}
